import useAppState from '../../context/AppContext';
import {useState} from "react";
import {IApiErrors, IPreContractDocument} from "../../context/model";
import {downloadPreContractDocument} from "../../services/CustomerApiService";
import {AxiosError} from "axios";
import LoaderModal from "../../modals/common/LoaderModal";
import MgpMessage from "../../elements/MgpMessage/MgpMessage";
import UploadFilePreviewModal from '../../modals/common/UploadFilePreviewModal';
import { handleKeyDown } from '../../utils/utils';


type PreContractDocumentProps = {
  preContractDocument: IPreContractDocument,
  onDocumentUpdate: (doc: IPreContractDocument) => void,
  handleSetMessageError: (message: string) => void
}

export default function PreContractDocumentComponent({ preContractDocument, onDocumentUpdate, handleSetMessageError }: Readonly<PreContractDocumentProps>) {
  const {
    state: { proposition, jwtToken },
    dispatch
  } = useAppState();

  const [loading, setLoading] = useState<boolean>(false);
  const [fileContent, setFileContent] = useState<any>(null);
  const [contractDocument, setContractDocument] = useState<IPreContractDocument>(preContractDocument);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const downloadPreContractDoc = async () => {
    try {
      handleSetMessageError('');
      setLoading(true);
      const res = await downloadPreContractDocument(jwtToken!.accessToken, proposition!.propositionId, contractDocument);
      setLoading(false);
      const blob = new Blob([res.data], {type: 'application/pdf'});
      return new File([blob], contractDocument.fileName)
    } catch (error) {
      setLoading(false);
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        handleSetMessageError("Erreur: " + errorData.message);
      } else {
        handleSetMessageError("Une erreur technique est survenue ");
      }
    }
  }

  const closeModal = () => {
    setModalIsOpen(false);
    dispatch({type: 'SHOW_MODAL', showModal: false});
  };

  const acceptDocument = () => {
    const preDoc = {...contractDocument, accepted: true};
    setContractDocument(preDoc);
    onDocumentUpdate(preDoc);
    closeModal();
  };
  const previewDoc = async () => {
    if (fileContent) {
      setModalIsOpen(true);
      dispatch({type: 'SHOW_MODAL', showModal: true});
      return;
    }

    const downloadedContent = await downloadPreContractDoc();

    if (downloadedContent) {
      setFileContent(downloadedContent);
      setModalIsOpen(true);
      dispatch({type: 'SHOW_MODAL', showModal: true});
    }
  };

  const downloadFile = (content: Blob) => {
    const a = document.createElement('a');
    a.download = contractDocument.fileName;
    a.href = window.URL.createObjectURL(content);
    a.click();
  };
  const onDownloadDocumentClick = async () => {
    if (fileContent) {
      downloadFile(fileContent);
      return;
    }

    const downloadedContent = await downloadPreContractDoc();

    if (downloadedContent) {
      downloadFile(downloadedContent);
      setFileContent(downloadedContent);
    }
  };

  const linkStyle = {backgroundColor: ''};
  let backgroundColor = 'bg-blanc';
  let spanMessage = 'A lire et accepter';
  if (contractDocument.accepted) {
    linkStyle.backgroundColor = 'rgb(0 170 160 / 13%)';
    spanMessage = 'Vu et accepté';
    backgroundColor = 'alert alert-bleu';
  }

  return (
    <>
      <div className={`${backgroundColor} form-row m-y-sm shadow-noir p-sm`}>
        <div className='form-group mw-60'>
          <p className="text fw-medium bleu ml-sm">
          {contractDocument.name}
          </p>
        </div>
 
        <div className='form-group mw-30'>
          {!contractDocument.accepted&&<div onClick={previewDoc} className='cta-bleu withicon' role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>
            <i className="icon-attention"></i>
              {spanMessage}
          </div>}
          {contractDocument.accepted&&
          <div className='cta-bleu withicon inverse button-disable'>
            <i className="icon-coche"></i>
              {spanMessage}
          </div>}
        </div>
        <div className='form-group mw-15  ta-right'>        
        <a className="download" 
          target='_blank' download={contractDocument.fileName} onClick={onDownloadDocumentClick} title="Téléchargement du document" role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>
          <i className="icon-telechargement fushia"></i>
        </a>
        
        </div>
        {loading && <LoaderModal hasMessage={false}/>}
      </div>

      {modalIsOpen && fileContent && <UploadFilePreviewModal file={fileContent as File} onUploadAction={acceptDocument} isOpen={modalIsOpen} onCloseModal={closeModal} buttonName='Accepter' showSubTitle={false}/>}
    </>
  );
}
